// removed by extract-text-webpack-plugin
module.exports = {"legend":"legend__3-mOA","textLabel":"textLabel__2Oftx","exportLegend":"exportLegend__1t9nN","legendWrapper":"legendWrapper__2RqEt","legendColor":"legendColor__2rZno","legendDescription":"legendDescription__3S9qZ","legendPercentage":"legendPercentage__1cSm1","perc":"perc__29QOt","textField":"textField__2Qb_A","dollor":"dollor__bVku_","donut":"donut__8TQt2","imageWrapper":"imageWrapper__V5Cd4","sdg_image":"sdg_image__1UGW8","svgIe":"svgIe__3MZcc","regularOtherLegend":"regularOtherLegend__3_IS2","legend_wrapper":"legend_wrapper__2Im90","legendText":"legendText__1jVSc"};


//////////////////
// WEBPACK FOOTER
// ./components/donorDonutChart/style.scss
// module id = OP7B
// module chunks = 0